import { colorConstants } from 'config/colorConstants';
import { KpiMetricType, priceSimulatorDataContext } from 'contexts/PriceSimulatorContext';
import React, { useContext } from 'react';
import KPICardComponent from './KPICardComponent';

const KPICardsComponent = () => {
    const { kpiMetrictsState, kpiMetricsLoading } = useContext(priceSimulatorDataContext);

    return (
        <div
            className={`h-640 jus flex gap-4 overflow-y-scroll greyBackgroundAlt p-4 text-center rounded`}
            style={{ backgroundColor: colorConstants.greyAlt1 }}
            id="price-sim-kpi-cards"
        >
            {kpiMetrictsState
                .filter((item) => item.selected)
                .map((item: KpiMetricType, index) => (
                    <KPICardComponent key={index} kpiMetic={item} loading={kpiMetricsLoading} />
                ))}
        </div>
    );
};

export default KPICardsComponent;
